export const actionsHeaderSx = {
  whiteSpace: 'nowrap',
  width: '1%',
};

export const actionsColumnSx = {
  whiteSpace: 'nowrap',
  width: '1%',
};

// Actions column holding a single RowActionsMenu kebab: narrow, centered, with
// tighter right padding on phones.
export const actionsKabobHeaderSx = {
  ...actionsHeaderSx,
  pl: 1,
  pr: { xs: 0.25, sm: 1 },
};

export const actionsKabobCellSx = {
  ...actionsColumnSx,
  pl: 1,
  pr: { xs: 0.25, sm: 1 },
};

